import { render, staticRenderFns } from "./OpportunityKanbanBoard.vue?vue&type=template&id=7e183303&scoped=true&"
import script from "./OpportunityKanbanBoard.vue?vue&type=script&lang=js&"
export * from "./OpportunityKanbanBoard.vue?vue&type=script&lang=js&"
import style0 from "./OpportunityKanbanBoard.vue?vue&type=style&index=0&id=7e183303&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e183303",
  null
  
)

export default component.exports